import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import userSlice from './slices/userSlice';
import supplierSlice from './slices/supplierSlice';
import customerSlice from './slices/customerSlice';
import orderStatusSlice from './slices/orderStatusSlice';
import orderSlice from './slices/orderSlice';
import orderTypeSlice from './slices/orderTypeSlice';
import statisticsSlice from './slices/statisticsSlice';
import clientTypeSlice from './slices/clientTypeSlice';
import articleSlice from './slices/articleSlice';
import carBrandSlice from './slices/carBrandSlice';
import brandDiscountSlice from './slices/brandDiscountSlice';
import articleTemplateSlice from './slices/articleTemplateSlice';
import articleGroupDiscountSlice from './slices/articleGroupDiscountSlice';
import articleDiscountSlice from './slices/articleDiscountSlice';

export const store = configureStore({
  reducer: {
    user: userSlice,
    supplier: supplierSlice,
    customer: customerSlice,
    orderStatus: orderStatusSlice,
    order: orderSlice,
    orderTypes: orderTypeSlice,
    statistics: statisticsSlice,
    clientType: clientTypeSlice,
    article: articleSlice,
    carBrand: carBrandSlice,
    brandDiscount: brandDiscountSlice,
    articleTemplate: articleTemplateSlice,
    articleGroupDiscount: articleGroupDiscountSlice,
    articleDiscount: articleDiscountSlice,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
